(function () {
  function initPromoSliders() {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-promo-slider]').forEach(function (slider) {
      if (slider.classList.contains('slick-initialized')) return;

      var slides = slider.querySelectorAll('[data-promo-slide]');
      if (slides.length < 2) return;

      var autoplay = slider.dataset.autoplay === 'true' && !prefersReducedMotion;
      var autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 4000;
      var showDots = slider.dataset.showDots === 'true';
      var showArrows = slider.dataset.showArrows === 'true';

      jQuery(slider).slick({
        dots: showDots,
        arrows: showArrows,
        infinite: true,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        appendDots: jQuery(slider).parent(),
        prevArrow:
          '<button type="button" class="promo-slider-arrow promo-slider-arrow--prev" aria-label="Previous slide"><span aria-hidden="true">&lsaquo;</span></button>',
        nextArrow:
          '<button type="button" class="promo-slider-arrow promo-slider-arrow--next" aria-label="Next slide"><span aria-hidden="true">&rsaquo;</span></button>'
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoSliders);
  } else {
    initPromoSliders();
  }

  document.addEventListener('shopify:section:load', initPromoSliders);
})();
